// extracted by mini-css-extract-plugin
module.exports = {"invoicePeriodWrapper":"InvoicePeriodWrapper_invoicePeriodWrapper__3yZ82"};